import { count } from '@components/config/helpers';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
const ProductDescription = dynamic(() => import('../ProductTabs/TabKeys/ProductDescription'))
const ProductVideos = dynamic(() => import('../ProductTabs/TabKeys/ProductVideos'))
const ProductReviews = dynamic(() => import('../ProductTabs/TabKeys/ProductReviews'))
const ProductMeasurements = dynamic(() => import('../ProductTabs/TabKeys/ProductMeasurements'))
const ProductFAQs = dynamic(() => import('../ProductTabs/TabKeys/ProductFAQs'))

const ProductToggleDesriptions = (props) => {

    const {
        alignment,
        product,
        product_description_long,
        long_term_product,
        long_desc,
        faqs,
        measurements,
        articles,
        videos,
        reviews,
        width,
        depth,
        height,
    } = props;

    return (
        <>

            {product_description_long && (
                <Box className={`${alignment != 'description' && 'd-none'} w-100`}>
                    <ProductDescription product_description_long={product_description_long} long_term_product={long_term_product} long_desc={long_desc}/>
                </Box>
            )}
            {faqs && count(faqs) > 0 && (
                <Box className={`${alignment != 'faq' && 'd-none'} w-100`}>
                    <ProductFAQs faqs={faqs} />
                </Box>
            )}
            {measurements && count(Object.keys(measurements)) > 0 && (
                <Box className={`${alignment != 'measurements' && 'd-none'} w-100`}>
                    <ProductMeasurements 
                        width={width} 
                        depth={depth} 
                        height={height} 
                        measurements={measurements} 
                        product={product}
                    />
                </Box>
            )}
            {articles && count(articles) > 0 &&  (
                <Box className={`${alignment != 'related_articles' && 'd-none'} w-100`}>
                    {/* <ProductArticles /> */}
                </Box>
            )}
            {videos && count(videos) > 0 &&  (
                <Box className={`${alignment != 'videos' && 'd-none'} w-100`}>
                    <ProductVideos videos={videos}/>
                </Box>
            )}
            {reviews && count(reviews) > 0 &&   (
                <Box className={`${alignment != 'reviews' && 'd-none'} w-100`}>
                   <ProductReviews reviews={reviews} product_id={product.product_id}/>
                </Box>
            )}
        </>
    )
}

export default ProductToggleDesriptions